var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.99998V2.76248C15 2.19998 14.325 1.92498 13.9375 2.32498L10.4375 5.81248C10.1875 6.06248 10.1875 6.44998 10.4375 6.69998L13.925 10.1875C14.325 10.575 15 10.3 15 9.73748V7.49998C19.1375 7.49998 22.5 10.8625 22.5 15C22.5 15.9875 22.3125 16.95 21.95 17.8125C21.7625 18.2625 21.9 18.775 22.2375 19.1125C22.875 19.75 23.95 19.525 24.2875 18.6875C24.75 17.55 25 16.3 25 15C25 9.47498 20.525 4.99998 15 4.99998ZM15 22.5C10.8625 22.5 7.5 19.1375 7.5 15C7.5 14.0125 7.6875 13.05 8.05 12.1875C8.2375 11.7375 8.1 11.225 7.7625 10.8875C7.125 10.25 6.05 10.475 5.7125 11.3125C5.25 12.45 5 13.7 5 15C5 20.525 9.475 25 15 25V27.2375C15 27.8 15.675 28.075 16.0625 27.675L19.55 24.1875C19.8 23.9375 19.8 23.55 19.55 23.3L16.0625 19.8125C15.675 19.425 15 19.7 15 20.2625V22.5V22.5Z",
    fill: "#507CF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.8dbe740ac47682048ae5a247e197bdce.svg";
export { ForwardRef as ReactComponent };